import { render } from "./PostsPage.vue?vue&type=template&id=6af3fc46"
import script from "./PostsPage.vue?vue&type=script&lang=js"
export * from "./PostsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__